import { SPORTS_DISTRICT_COMPANY_ID } from '../Utils/constants';
import { COLORS } from '../Utils/colors';
import { SD_COLORS, SD_MUI_FONT_FAMILY, SD_HTML_FONT_SIZE } from '../config/sportsDistrictBrand';

export interface CompanyThemeOptions {
  fontFamily?: string;
  useRegularFontWeight?: boolean;
  htmlFontSize?: number;
}

export const getCompanyPrimaryColor = (
  companyId?: string,
  primaryColor?: string
): string => {
  if (primaryColor) return primaryColor;
  if (companyId === SPORTS_DISTRICT_COMPANY_ID) return SD_COLORS.navy;
  return COLORS.blue;
};

export const getCompanyThemeOptions = (companyId?: string): CompanyThemeOptions | undefined => {
  if (companyId === SPORTS_DISTRICT_COMPANY_ID) {
    return {
      fontFamily: SD_MUI_FONT_FAMILY,
      useRegularFontWeight: true,
      htmlFontSize: SD_HTML_FONT_SIZE,
    };
  }

  return undefined;
};

export const isSportsDistrictCompany = (companyId?: string): boolean =>
  companyId === SPORTS_DISTRICT_COMPANY_ID;
